// import { useSelector } from "react-redux";
import { AppRoutes } from "../constants";

// const { accessToken, permissions } = useSelector((state) => state.Login);
export const sidebarRoutes = [
  {
    name: "Menu",
    links: [
      {
        name: "Dashboard",
        routeTo: AppRoutes.HOME,
        icon: "bx bx-home-circle",
      },
    ],
  },
  {
    name: "Branch Management",
    links: [
      {
        name: "Branches",
        routeTo: AppRoutes.BRANCHES,
        icon: "bx bx-building",
      },
      {
        name: "Expenses",
        routeTo: AppRoutes.EXPENSES,
        icon: "bx bx-receipt",
        subLinks: [
          { name: "Add new Expense", routeTo: AppRoutes.CREATE_EXPENSE },
          { name: "View Expenses", routeTo: AppRoutes.EXPENSES },
        ],
      },
      {
        name: "Accounts",
        routeTo: AppRoutes.ACCOUNTS,
        icon: "bx bx-wallet",
      },
    ],
  },

  {
    name: "Product Management",
    links: [
      {
        name: "Products",
        routeTo: AppRoutes.PRODUCTS,
        icon: "bx bx-package",
        subLinks: [
          { name: "Add new Product", routeTo: AppRoutes.CREATE_PRODUCT },
          { name: "View Products", routeTo: AppRoutes.PRODUCTS },
        ],
      },
      {
        name: "Category",
        routeTo: AppRoutes.CATEGORIES,
        icon: "bx bx-box",
      },
      {
        name: "Product Transfer",
        routeTo: AppRoutes.PRODUCT_TRANSFERS,
        icon: "bx bx-transfer",
        subLinks: [
          {
            name: "Add Product Transfer",
            routeTo: AppRoutes.ADD_PRODUCT_TRANSFER,
          },
          {
            name: "View Product Transfers",
            routeTo: AppRoutes.PRODUCT_TRANSFERS,
          },
        ],
      },
    ],
  },
  {
    name: "Weighbill Management",
    links: [
      {
        name: "Weighbills",
        routeTo: AppRoutes.WEIGHBILLS,
        icon: "bx bx-detail",
        subLinks: [
          { name: "Add new Weighbill", routeTo: AppRoutes.CREATE_WEIGHBILL },
          { name: "View Weighbills", routeTo: AppRoutes.WEIGHBILLS },
        ],
      },
    ],
  },
  {
    name: "USER CONTROL",
    links: [
      {
        name: "Suppliers",
        routeTo: AppRoutes.SUPPLIERS,
        icon: "bx bx-store-alt",
        subLinks: [
          { name: "Add new Supplier", routeTo: AppRoutes.CREATE_SUPPLIER },
          { name: "View Suppliers", routeTo: AppRoutes.SUPPLIERS },
        ],
      },
      {
        name: "Customers",
        routeTo: AppRoutes.CUSTOMERS,
        icon: "bx bx-group", // or any of the other suggested icons
      },
    ],
  },
  {
    name: "Order management",
    links: [
      {
        name: "Orders",
        routeTo: AppRoutes.ORDERS,
        icon: "bx bx-list-ul",
      },
    ],
  },
  {
    name: "Sales",
    links: [
      // {
      //   name: "My Online Shop",
      //   routeTo: "/",
      //   icon: "bx bx-store",
      // },
      {
        name: "Point of Sale",
        routeTo: "/pos",
        icon: "bx bx-shopping-bag",
      },
    ],
  },
  {
    links: [
      {
        name: "Settings",
        routeTo: AppRoutes.SETTINGS,
        icon: "bx bx-cog",
      },
    ],
  },
];
